import type Geometry from "ol/geom/Geometry";
import LineString from "ol/geom/LineString";
import Polygon from "ol/geom/Polygon";
import { getArea } from "ol/sphere";
import CircleStyle from "ol/style/Circle";
import Fill from "ol/style/Fill";
import Stroke from "ol/style/Stroke";
import Style from "ol/style/Style";

import { formatArea, formatLength } from "./format";

export function createMeasureStyle(): Style {
  const fillColor = "rgba(147, 193, 61, 0.18)";
  const strokeColor = "#5d8f13";

  return new Style({
    fill: new Fill({ color: fillColor }),
    stroke: new Stroke({ color: strokeColor, width: 2 }),
    image: new CircleStyle({
      radius: 5,
      fill: new Fill({ color: fillColor }),
      stroke: new Stroke({ color: strokeColor, width: 2 }),
    }),
  });
}

export function isValidMeasureGeometry(geometry: Geometry): boolean {
  if (geometry instanceof Polygon) {
    const ring = geometry.getLinearRing(0);
    return !!ring && ring.getCoordinates().length > 3;
  }

  if (geometry instanceof LineString) {
    return geometry.getCoordinates().length > 1;
  }

  return false;
}

export function getMeasureTooltipCoordinate(
  geometry: Geometry,
): number[] | undefined {
  if (geometry instanceof Polygon) {
    if (!isValidMeasureGeometry(geometry)) return undefined;
    return geometry.getInteriorPoint().getCoordinates();
  }

  if (geometry instanceof LineString) {
    const coordinates = geometry.getCoordinates();
    if (coordinates.length <= 1) return undefined;
    return coordinates[coordinates.length - 1];
  }

  return undefined;
}

export function formatMeasureGeometry(
  geometry: Geometry,
  locale?: string,
): string | null {
  if (!isValidMeasureGeometry(geometry)) return null;

  if (geometry instanceof Polygon) {
    return formatArea(getArea(geometry), locale);
  }

  if (geometry instanceof LineString) {
    return formatLength(geometry, locale);
  }

  return null;
}
